module.exports = __webpack_public_path__ + "static/media/bowen-4.78bd18e2.jpg";